import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import Dashboard from "@/views/Dashboard";
import Login from "./views/Login";
import firebase from "firebase";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
      // },
      // {
      //   path: '/Test',
      //   name: 'test',
      //   component: () => import(/* webpackChunkName: "about" */ './views/Test.vue')
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  //check to see if route requires auth
  if (to.matched.some((rec) => rec.meta.requiresAuth)) {
    //check auth state of user

    let user = firebase.auth().currentUser;
    if (user) {
      //user signed in, proceed to route
      next();
    } else {
      //no sing in
      //console.log('not signed in')
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router;
